<template>
  <div :data-hasSlot="setLabelSlot" :class="{ labelFixed }">
    <h3 :class="['headingLv3', { band }, { simple }]" v-html="text"></h3>
    <p v-if="setLabelSlot" class="headingLv3_label">
      <slot></slot>
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'HeadingLv3',

  props: {
    text: String,
    setLabelSlot: {
      type: Boolean,
      default: false
    },
    labelFixed: {
      type: Boolean,
      default: false
    },
    band: {
      type: Boolean,
      default: false
    },
    simple: {
      type: Boolean,
      default: false
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.labelFixed {
  display: flex;
  align-items: center;
  justify-content: space-between;
  @include mixins.media() {
    justify-content: flex-start;
  }
  p {
    margin: 0;
    @include mixins.media() {
      margin-left: 5px;
    }
  }
}

.headingLv3 {
  padding-left: 10px;
  border-left: 4px solid var.$color-main;
  font-size: 1.8rem;
  font-weight: 500;
  line-height: 1.5;

  &.band {
    display: flex;
    align-items: center;
    min-height: 50px;
    margin-left: -16px;
    margin-right: -16px;
    padding-left: 16px;
    padding-right: 16px;
    background-color: #e7f8f6;
    font-weight: 500;
    font-size: 2rem;
    letter-spacing: 0.03em;
    line-height: 1.6;
    border-left: none;
  }
  &.simple {
    border-left: none;
    padding-left: 0;
    text-align: center;
    font-size: 2rem;
    letter-spacing: 0.03em;
    font-weight: 500;
  }

  @include mixins.media() {
    display: inline-block;
    vertical-align: middle;
  }
}

::v-deep(.headingLv3_label) {
  margin-top: 6px;
  margin-left: 10px;
  font-size: 1rem;

  @include mixins.media() {
    display: inline-block;
    vertical-align: middle;
    margin: 0;
  }

  em {
    display: inline-block;
    width: 50px;
    height: 20px;
    font-style: normal;
    font-weight: bold;
    background-color: var.$color-main;
    color: #fff;
    text-align: center;
    line-height: 20px;
    font-weight: 900;
    &.optional {
      background-color: var.$color-gray;
    }
  }
  em + span {
    margin-left: 15px;
  }
}
</style>
